var map = {
	"./FH/icon-ds.png": 75003,
	"./FH/jili-fish.png": 68309,
	"./LC/ag_casino.png": 67347,
	"./LC/dg_casino.png": 66946,
	"./LC/ebet_casino.png": 29053,
	"./LC/evl_casino.png": 41298,
	"./LC/pragmatic_casino.png": 99055,
	"./LC/pt-live.png": 53454,
	"./LC/sa_casino.png": 91967,
	"./LC/sg_casino.png": 89165,
	"./LC/tin888.png": 20338,
	"./LC/wm_casino.png": 74223,
	"./SB/ag-sport.png": 88724,
	"./SB/btisport.png": 36150,
	"./SB/cmd.png": 29605,
	"./SB/ibc.png": 87193,
	"./SL/dragoon-slot.png": 20728,
	"./SL/habanero-slot.png": 12002,
	"./SL/jili-slot.png": 94076,
	"./SL/pg-slot.png": 74271,
	"./SL/pragmatic-slot.png": 22574,
	"./SL/pt-slot.png": 65598,
	"./V8/v8-poker.png": 84996
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20240;